import axiosInstance from "../../utils/AxiosInstance";

export interface Company {
  id: string;
  name: string;
  logo: string | null;
  loginImage: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  tertiaryColor: string | null;
}

export interface CreateCompanyBody {
  name: string;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
  logo?: string;
  loginImage?: string;
  adminFullName: string;
  adminEmail: string;
}

export interface UpdateCompanyBody {
  name?: string;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
  logo?: string;
  loginImage?: string;
}

export interface CreateCompanyResponse {
  company: Company;
  adminEmail: string;
}

export function listCompanies(): Promise<Company[]> {
  return axiosInstance.get<Company[]>("/companies").then((response) => response.data);
}

export function createCompany(body: CreateCompanyBody): Promise<CreateCompanyResponse> {
  return axiosInstance
    .post<CreateCompanyResponse>("/companies", {
      name: body.name,
      primary_color: body.primaryColor,
      secondary_color: body.secondaryColor,
      tertiary_color: body.tertiaryColor,
      logo: body.logo,
      login_image: body.loginImage,
      admin_full_name: body.adminFullName,
      admin_email: body.adminEmail,
    })
    .then((response) => response.data);
}

export function updateCompany(id: string, body: UpdateCompanyBody): Promise<Company> {
  return axiosInstance
    .put<Company>(`/companies/${encodeURIComponent(id)}`, {
      name: body.name,
      primary_color: body.primaryColor,
      secondary_color: body.secondaryColor,
      tertiary_color: body.tertiaryColor,
      logo: body.logo,
      login_image: body.loginImage,
    })
    .then((response) => response.data);
}
